/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForLocationOutput
 */
export interface CriteriaForLocationOutput {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    airportCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    airportName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    cityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    countryName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationOutput
     */
    isInboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationOutput
     */
    isInboundDeparture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationOutput
     */
    isOutboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationOutput
     */
    isOutboundDeparture?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    regionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationOutput
     */
    regionName?: string | null;
}

export function CriteriaForLocationOutputFromJSON(json: any): CriteriaForLocationOutput {
    return CriteriaForLocationOutputFromJSONTyped(json, false);
}

export function CriteriaForLocationOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForLocationOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airportCode': !exists(json, 'airportCode') ? undefined : json['airportCode'],
        'airportName': !exists(json, 'airportName') ? undefined : json['airportName'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'cityName': !exists(json, 'cityName') ? undefined : json['cityName'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'countryName': !exists(json, 'countryName') ? undefined : json['countryName'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isInboundArrival': !exists(json, 'isInboundArrival') ? undefined : json['isInboundArrival'],
        'isInboundDeparture': !exists(json, 'isInboundDeparture') ? undefined : json['isInboundDeparture'],
        'isOutboundArrival': !exists(json, 'isOutboundArrival') ? undefined : json['isOutboundArrival'],
        'isOutboundDeparture': !exists(json, 'isOutboundDeparture') ? undefined : json['isOutboundDeparture'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
        'regionName': !exists(json, 'regionName') ? undefined : json['regionName'],
    };
}

export function CriteriaForLocationOutputToJSON(value?: CriteriaForLocationOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airportCode': value.airportCode,
        'airportName': value.airportName,
        'cityCode': value.cityCode,
        'cityName': value.cityName,
        'countryCode': value.countryCode,
        'countryName': value.countryName,
        'exclude': value.exclude,
        'isInboundArrival': value.isInboundArrival,
        'isInboundDeparture': value.isInboundDeparture,
        'isOutboundArrival': value.isOutboundArrival,
        'isOutboundDeparture': value.isOutboundDeparture,
        'regionCode': value.regionCode,
        'regionName': value.regionName,
    };
}


